import { useContext, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { Link, useNavigate, useParams } from 'react-router-dom';

import { BodyWrapper, Header, Loader, MainWrapper, Message } from '@components';
import { blogCategoryMutation, siteQuery } from '@queries';
import { ChevronRightIcon, SearchIcon } from '@svgs';

import BlogCategoryForm from '../components/BlogCategoryForm/BlogCategoryForm.jsx';
import { SiteBreadcrumbs } from '../components/SiteBreadcrumbs/SiteBreadcrumbs.jsx';
import SiteSidebar from '../components/SiteSidebar/SiteSidebar.jsx';

export const AddBlogCategory = () => {
  const { t, i18n } = useTranslation();
  const { siteID } = useParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  // get site
  const { data: siteData, isPending: siteIsPending } = useQuery(
    siteQuery(siteID),
  );

  // save author
  const mutation = useMutation(
    blogCategoryMutation(null, {
      onSuccess: (data) => {
        // invalidate the lists so its purged
        queryClient.invalidateQueries({ queryKey: ['categories', 'list'] });
        // navigate to the edit view
        navigate(`/dashboard/sites/${siteID}/blogs/categories/${data.id}`);
      },
    }),
  );

  const defaultBlogCategory = {
    site_id: siteID,
  };

  return (
    <>
      <Header />
      <BodyWrapper>
        <SiteSidebar siteID={siteID} siteData={siteData} />
        <MainWrapper>
          <SiteBreadcrumbs siteData={siteData}>
            <li className="sb-flex">
              <Link to={`/dashboard/sites/${siteID}/blogs`}>Blogs</Link>
              <ChevronRightIcon />
            </li>
            <li className="sb-flex">
              <Link to={`/dashboard/sites/${siteID}/blogs/categories`}>
                {t('Blog categories')}
              </Link>
              <ChevronRightIcon />
            </li>
            <li className="sb-flex">
              <span>Add</span>
            </li>
          </SiteBreadcrumbs>
          <div className="sb-manage-content">
            <BlogCategoryForm
              blogCategoryData={defaultBlogCategory}
              mutation={mutation}
              disabled={mutation.isPending}
              onCancel={() => {
                navigate(`/dashboard/sites/${siteID}/blogs/categories`);
              }}
            />
          </div>
        </MainWrapper>
      </BodyWrapper>
    </>
  );
};
